import { NotificationsSidebarStatus, NotificationType } from '@enums/notifications';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { VolumeNotification } from '@models/notification';
import { IntervalHelper } from '@helpers/interval.helper';
import moment from 'moment';

@Injectable({
	providedIn: 'root',
})
export class NotificationsService {
	// Migrated to signals from BehaviorSubject
	notificationsSidebarStatus: WritableSignal<NotificationsSidebarStatus> = signal(
		NotificationsSidebarStatus.Close,
	);

	notificationTypeSelected: WritableSignal<NotificationType> = signal(NotificationType.Volume);

	volumeNotifications: WritableSignal<VolumeNotification[]> = signal([]);

	constructor() {}

	toggleNotificationsSidebarStatus(): void {
		const currentStatus = this.notificationsSidebarStatus();
		this.notificationsSidebarStatus.set(
			currentStatus === NotificationsSidebarStatus.Close
				? NotificationsSidebarStatus.Open
				: NotificationsSidebarStatus.Close,
		);
	}

	selectType(type: NotificationType): void {
		this.notificationTypeSelected.set(type);
	}

	/**
	 * Load volume notifications - returns empty since Rust API doesn't have this endpoint
	 */
	loadVolumeNotifications(): void {
		// Rust API doesn't have volume notifications endpoint
		// Return empty array
		this.volumeNotifications.set([]);
	}

	updateVolumeNotifications(notifications: VolumeNotification[]): void {
		const intervals = IntervalHelper.intervalsMap();
		const newNotifications = notifications.map((n) => {
			n.change = Number((Math.round(n.change * 100) / 100).toFixed(2));
			n.interval_label = intervals.get(n.interval)?.label ?? '';
			n.date = moment(n.timestamp).format('YYYY-MM-DD HH:mm');

			return n;
		});
		const currentNotifications = this.volumeNotifications();

		this.volumeNotifications.set([...newNotifications, ...currentNotifications]);
	}
}
